(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    const themeStorageKey = 'tokyo-hours-theme-v2';
  const root = document.documentElement;
  const toggles = () => document.querySelectorAll('[data-day-night-toggle]');

  const applyStoreTheme = (mode) => {
    root.dataset.storeTheme = mode;
    toggles().forEach((toggle) => {
      toggle.setAttribute('aria-pressed', mode === 'night' ? 'true' : 'false');
    });
  };

  let savedTheme = null;
  try {
    savedTheme = localStorage.getItem(themeStorageKey);
  } catch (error) {
    savedTheme = null;
  }

  applyStoreTheme(savedTheme === 'night' ? 'night' : 'day');

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-day-night-toggle]');
    if (!toggle) return;

    const nextTheme = root.dataset.storeTheme === 'night' ? 'day' : 'night';
    applyStoreTheme(nextTheme);

    try {
      localStorage.setItem(themeStorageKey, nextTheme);
    } catch (error) {
      return;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
